import styled from 'styled-components';
import { TrackingHeader } from '../TrackingHeader';
import { SearchBar } from '../SearchBar';
import { theme } from '../../styles/theme';
import { gray3, gray0, accent4, focus } from 'emerald-ui/dist/globals/colors';
import { InputBar_Input } from 'emerald-ui';
import { font } from 'emerald-ui/dist/globals/fonts';

export const HomeContent_Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 2rem;
    max-width: 44em;
    margin: 0 auto;
`;

export const HomeContent_TrackingHeader = styled(TrackingHeader)`
    font-size: 4.5rem;
    margin-bottom: 2rem;
    line-height: 1;
    ${theme.breakpoints.only('xs')} {
        font-size: 3rem;
    }
`;

export const HomeContent_Message = styled.div`
    color: ${accent4};
    font-family: ${font.light};
    font-size: 1rem;
    text-align: center;
    ${theme.breakpoints.only('xs')} {
        font-size: .75rem;
    }
    a {
        color: ${focus};
    }
`;

export const HomeContent_SearchBar = styled(SearchBar)`
    margin-bottom: 2rem;
    background: ${gray0} !important;
    width: 100%;
    border: 2px solid ${gray3};

    ${InputBar_Input} {
        font-size: 2rem;
        font-family: ${font.light};
        background: ${gray0};

        ${theme.breakpoints.down('sm')} {
            font-size: 1.5rem;
        }
    }
`;
